"use strict";

import angular from "angular";
import "../Common/directives";
import { FormHelpersService } from "../Common/FormHelpersService";
import "../../../Scripts/autofill-event.js";

const MODULE_NAME = "GFC.Login";

angular.module(MODULE_NAME, ["GFC.directives"])
       .service("FormHelpers", FormHelpersService)
       .controller("LoginController", ["$scope", function ($scope) {
           $scope.title = "Sign In";

           $scope.login = function (event) {
               if ($scope.loginForm.$invalid) {
                   angular.forEach($scope.loginForm.$error.required, function (field) {
                       field.$setDirty();
                   });

                   event.preventDefault();
               } else {
                   $scope.title = "Signing in, please wait…";
                   $scope.isBusy = true;
               }
           }
       }]);

export default MODULE_NAME;
